import React from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Fab from '@material-ui/core/Fab'
import Tooltip from '@material-ui/core/Tooltip'
import DoneIcon from '@material-ui/icons/Done'
import { withStyles } from '@material-ui/core/styles'
import classNames from 'classnames'
import styles from 'components/styles'
import {
  /* saveTemplate, */ createTemplate,
  updateTemplate,
} from 'actions/template'
import language from 'utils/vast-languagepack'

export default withRouter(
  connect(
    (state) => ({
      disabled: !state.email.templateName.value.length,
      templateID: state.email.templateID,
    }),
    (dispatch) =>
      bindActionCreators(
        { /* saveTemplate, */ createTemplate, updateTemplate },
        dispatch,
      ),
  )(
    withStyles(styles)(
      ({
        classes,
        disabled,
        /* saveTemplate, */ history,
        templateID,
        createTemplate,
        updateTemplate,
      }) => {
        return (
          <Tooltip
            title={language.templatePage.templateFormPage.saveTemplate}
            placement='left'
          >
            <Fab
              disabled={disabled}
              color='secondary'
              aria-label='Save'
              className={classNames(
                classes.button,
                classes.floatingActionButton
              )}
              onClick={() => {
                if (templateID === 'new') {
                  createTemplate().then((payload) => {
                    if (payload.id) {
                      history.replace(`/templates/${payload.id}`);
                    }
                  });
                } else {
                  updateTemplate();
                }
              }}
            >
              <DoneIcon />
            </Fab>
          </Tooltip>
        );
      },
    ),
  ),
)
